/* One clock per build.
 *
 * The demo called Date.now() at every date it wrote, which is fine in a browser and
 * useless in a test: two builds a millisecond either side of midnight are different
 * gyms. A build takes its `now` once and every date in it is derived from that instant,
 * so "two builds at the same size are byte-identical" is a property rather than a hope.
 *
 * LOCAL calendar dates, not UTC, carried over from localISO() in util.js: a gym's today
 * is the day it is at the gym, and toISOString() makes an evening check-in belong to
 * tomorrow from 5pm Pacific onwards. */
const DAY = 86_400_000;
export class Clock {
    nowMs;
    constructor(nowMs = Date.now()) {
        this.nowMs = nowMs;
    }
    /** Local 'YYYY-MM-DD' for an instant. */
    iso(ms) {
        const d = new Date(ms);
        return new Date(ms - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    }
    today() {
        return this.iso(this.nowMs);
    }
    /** `n` days back. Negative `n` is the future, which is what a renewal date is. */
    daysAgo(n) {
        return this.iso(this.nowMs - n * DAY);
    }
    /** Whole days between a date and today. Anchored at noon so a DST change does not
     *  turn a same-day comparison into 0.96 of a day and round the wrong way. */
    ago(d) {
        if (!d)
            return null;
        return Math.round((this.nowMs - new Date(d + 'T12:00:00').getTime()) / DAY);
    }
    /** `ago`, never negative: "how long since" cannot be -3. */
    since(d) {
        const n = this.ago(d);
        return n == null ? 0 : Math.max(0, n);
    }
}
